import React from "react";
import { CheckCircle2 } from "lucide-react";
import { GUARANTEES } from "@/data/guarantees";

export default function GuaranteesList({ variant = "web" }) {
  const isPrint = variant === "print";
  return (
    <ul className={isPrint ? "space-y-1.5 my-2" : "space-y-2"} data-testid="guarantees-list">
      {GUARANTEES.map((g, i) => (
        <li key={i} className={`flex gap-2 ${isPrint ? "text-sm text-slate-700" : "text-slate-600"}`}>
          <CheckCircle2 className={`${isPrint ? "w-4 h-4" : "w-5 h-5"} text-[#F97316] flex-shrink-0 mt-0.5`} />
          <span><span className="font-semibold text-navy">{g.title}</span> — {g.short}</span>
        </li>
      ))}
    </ul>
  );
}
